import { useSelector } from 'react-redux';
import { includes } from 'lodash';

import { ClaimStatuses } from '@models/Claim';
import { selectIsFrontline } from '@components/Auth';
import { CarClaim } from '@models/CarClaim';
import { CancerClaim } from '@models/CancerClaim';
import { PersonalAccidentClaim } from '@models/PersonalAccidentClaim';
import { CorporateHealthClaim } from '@models/CorporateHealthClaim';
import { HealthClaim } from '@models/HealthClaim';

type Prop = CarClaim | CancerClaim | PersonalAccidentClaim | CorporateHealthClaim | HealthClaim | undefined | null;

export const useEditable = (claimable: Prop) => {
  const isFrontline = useSelector(selectIsFrontline);
  const allowedStatuses =
    claimable &&
    includes(
      [ClaimStatuses.Open, ClaimStatuses.InReview, ClaimStatuses.InProgress, ClaimStatuses.SettlementOffered],
      claimable.status
    );

  return isFrontline && allowedStatuses;
};
